//@ts-check

class PagingService {
	constructor(NavigationService) {
		this.NavigationService = NavigationService;

		this.init();
	}

	init() {
		this.limit = 5;
		this.maxPage = 1;
		this.pageNumber = 1;
		this.lastItemIndex = 5;
		this.scrollSpeed = 100;
		this.firstItemIndex = 1;
		this.numberOfResults = 0;

		this.maxPageLegal = 1;
		this.lastItemIndexLegal = 5;
		this.firstItemIndexLegal = 1;
		this.numberOfResultsLegal = 0;
	}

	getFirstLegal() {
		if (this.pageNumber !== 1) {
			this.pageNumber = 1;

			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}

	getPreviousLegal() {
		if (this.pageNumber > 1) {
			this.pageNumber = this.pageNumber - 1;
			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}

	getNextLegal() {
		if (this.pageNumber < this.maxPageLegal) {
			this.pageNumber = this.pageNumber + 1;
			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}

	getLastLegal() {
		if (this.pageNumber !== this.maxPageLegal) {
			this.pageNumber = this.maxPageLegal;
			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}
	
	getFirst() {
		if (this.pageNumber !== 1) {
			this.pageNumber = 1;

			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}

	getPrevious() {
		if (this.pageNumber > 1) {
			this.pageNumber = this.pageNumber - 1;
			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}

	getNext() {
		if (this.pageNumber < this.maxPage) {
			this.pageNumber = this.pageNumber + 1;
			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}

	getLast() {
		if (this.pageNumber !== this.maxPage) {
			this.pageNumber = this.maxPage;
			this.NavigationService.gotoTop(this.scrollSpeed);
		}
	}
}

export default /* @ngInject */ (NavigationService) => new PagingService(NavigationService);
